
import React, { useState } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { toast } from "sonner";
import { updateShop } from "@/lib/supabase/shops";
import { Shop } from "@/components/dashboard/shops/types";
import { ProfileSectionHeader } from "./ProfileSectionHeader";
import { ProfileSectionForm } from "./ProfileSectionForm";

interface ProfileSectionProps {
  shop: Shop;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({ shop }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isGeneratingSlug, setIsGeneratingSlug] = useState(false);
  const [name, setName] = useState(shop.name);
  const [description, setDescription] = useState(shop.description || "");
  const [category, setCategory] = useState(shop.category || "");
  const [logoUrl, setLogoUrl] = useState(shop.logo_url || "");
  const [slug, setSlug] = useState(shop.slug || "");

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error("Le nom de la boutique ne peut pas être vide");
      return;
    }
    
    if (!slug.trim()) {
      toast.error("Le slug de la boutique ne peut pas être vide");
      return;
    }
    
    try {
      setIsSaving(true);
      
      const shopData = {
        name,
        description,
        category,
        logo_url: logoUrl,
        slug
      };
      
      const { success, error } = await updateShop(shop.id, shopData);
      
      if (success) {
        toast.success("Modifications enregistrées avec succès", {
          description: "Les informations de la boutique ont été mises à jour."
        });
        setIsEditing(false);
      } else {
        throw new Error(error?.message || "Une erreur est survenue lors de la mise à jour de la boutique");
      }
    } catch (error: any) {
      toast.error("Erreur", {
        description: error.message || "Une erreur est survenue lors de la mise à jour de la boutique"
      });
    } finally {
      setIsSaving(false);
    }
  };
  
  return (
    <div className="md:col-span-2">
      <Card className="shadow-md border-0 dark:border dark:border-gray-800">
        <CardHeader className="pb-2">
          <ProfileSectionHeader 
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            isSaving={isSaving}
          />
        </CardHeader>
        <CardContent>
          <ProfileSectionForm
            shop={shop}
            isEditing={isEditing}
            isSaving={isSaving}
            isGeneratingSlug={isGeneratingSlug}
            name={name}
            setName={setName}
            description={description}
            setDescription={setDescription}
            category={category}
            setCategory={setCategory}
            logoUrl={logoUrl}
            setLogoUrl={setLogoUrl}
            slug={slug}
            setSlug={setSlug}
            handleSave={handleSave}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default ProfileSection;
